export class QuizQuestions {

    questionNumber = 0;
    question = '';
    radioButtons = '';
    score = 0;

    constructor() {
        this.init();
    }

    init() {
        const list = $('.question-list');
        if (!list.length) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        this.processQuestions();
        this.resetForm();
        this.gameCounter();
        this.fullScreen();
    }

    processQuestions() {
        $('.quiz__next-btn').on('click', (event) => {
            // Get the value of the question.
            this.questionNumber = $(event.target).data('question-number');
            if (!this.questionNumber) {
                return;
            }

            // Call the function to navigate to the target form question.
            this.navigateToFormQuestion();
        });
    }

    // Define a function to navigate betweens form questions.
    navigateToFormQuestion() {
        // Hide all form questions.
        $('.question-item').addClass('question-item--hidden');

        // Show the current form question (as passed to the function).
        this.question = $('#question-item-' + this.questionNumber);
        if (this.question.length === 0) {
            return;
        }

        this.checkRadioButtons();
        this.paintCongratulations();

        this.question.removeClass('question-item--hidden');
    };

    checkRadioButtons() {
        this.radioButtons = this.question.find('input[type="radio"]');
        this.radioButtons.on('click', (event) => {
            event.stopImmediatePropagation();
            this.optionIsRight($(event.target));
        });
    }

    optionIsRight(radioButton) {
        const questionId = this.question.data('id-question');
        const url = '/tmdcontentquiz/question/' + questionId;
        $.ajax({
            url: url,
            method: 'GET',
            data: {
                optionSelected: radioButton.val()
            }
        })
            .done((res) => {
                let colorClass = 'question-item--wrong';
                if (res.data.isRight) {
                    colorClass = 'question-item--correct';
                    this.score = this.score + 1;
                }

                // Paint selected option
                radioButton.parent().addClass(colorClass);

                // Paint correct option
                this.radioButtons.each((index, el) => {
                    const element = $(el);
                    if (index + 1 === res.data.correctOption) {
                        // Paint on label
                        element.parent().addClass('question-item--correct');
                    }
                    element.attr('disabled', true);
                    element.parent().addClass('question-item--disabled');
                });

                this.question.find('.quiz__next-btn').attr('disabled', false);
            })
            .fail((err) => {
                console.debug(err);
            });
    }

    paintCongratulations() {
        const scoreMsg = this.question.find('#quiz__score-num-msg');
        if (scoreMsg) {
            scoreMsg.text(this.score);
        }

        const congratulationMsg = this.question.find('.quiz__congratulations');
        const congratulationImg = this.question.find('.quiz__img').find('img');
        if (congratulationMsg
            && congratulationImg) {

            let msg = '';
            let imgSrc = '/static/BB3HTML/app/images/quiz/quiz_congratulations.png';
            const totalQuestions = this.question.find('#quiz__score-num-total');
            if (totalQuestions.length === 0) {
                return;
            }

            const numTotalQuestions = parseInt(totalQuestions[0].innerText);
            if (this.score <= (numTotalQuestions * 1/3)) {
                msg = '¡Ups!';
                imgSrc = '/static/BB3HTML/app/images/quiz/quiz_congratulations_bad.png';
            } else if (this.score <= (numTotalQuestions * 2/3)) {
                msg = '¡Sabes hacerlo mejor, seguro!';
                imgSrc = '/static/BB3HTML/app/images/quiz/quiz_congratulations_regular.png';
            } else {
                msg = '¡Enhorabuena!';
                imgSrc = '/static/BB3HTML/app/images/quiz/quiz_congratulations_good.png';
            }

            congratulationMsg.text(msg);
            congratulationImg.attr('src', imgSrc);
        }
    }

    resetForm() {
        const resetButton = $('#quiz-reset');
        resetButton.on('click', () => {
            this.questionNumber = 0;
            this.question = '';
            this.radioButtons = '';
            this.score = 0;
            $('.quiz-form').find('.quiz__next-btn').not(':first').not(':last').not(':nth-last-child(2)').prop('disabled', true);
            $('input[type="radio"]').prop('checked', false).removeAttr('disabled');
            $('.question-item--correct, .question-item--wrong, .question-item--disabled').removeClass('question-item--correct question-item--wrong question-item--disabled');

            // Call the function to navigate to the target form question.
            this.navigateToFormQuestion(this.questionNumber);
        });
    }

    gameCounter() {
        const startButton = $('#quiz-start');
        startButton.on('click', (event) => {
            const intContentId = $(event.target).data('intcontentid');
            const data = 'intContentId=' + intContentId;

            const url = '/tmdcontentquiz/gamecounter/';
            $.ajax({
                url: url,
                type: 'POST',
                data: data
            })
                .done((res) => {
                    return res;
                })
                .fail((err) => {
                    console.debug(err);
                });
        });
    }

    fullScreen() {
        const fullScreenButton = $('.quiz__full-screen-btn');
        if (fullScreenButton.length) {
            fullScreenButton.on('click', () => {
                $('body').toggleClass('fullscreen');
            });
        }
    }
}
